export interface PickupRequestSheetActionTypes {
  type: PickupRequestSheetActions;
  payload?: any;
}

export enum PickupRequestSheetActions {
  GET_PICKUP_REQUEST_SHEET_BY_ID = "GET_PICKUP_REQUEST_SHEET_BY_ID",
  SET_PICKUP_REQUEST_SHEET_BY_ID = "SET_PICKUP_REQUEST_SHEET_BY_ID",
  CREATE_PICKUP_REQUEST_SHEET = "CREATE_PICKUP_REQUEST_SHEET",
  EDIT_PICKUP_REQUEST_SHEET_BY_ID = "EDIT_PICKUP_REQUEST_SHEET_BY_ID",
  GET_PICKUP_REQUEST_SHEET_LIST = "GET_PICKUP_REQUEST_SHEET_LIST",
  SET_PICKUP_REQUEST_SHEET_LIST = "SET_PICKUP_REQUEST_SHEET_LIST",
  SET_PICKUP_REQUEST_SHEET_PAGE_COUNT = "SET_PICKUP_REQUEST_SHEET_PAGE_COUNT",
  SET_PICKUP_STATUS = "SET_PICKUP_STATUS",
  SET_PICKUP_TYPE = "SET_PICKUP_TYPE",
}
